import React, { useState, useEffect } from 'react';
import { Heading } from '../../components/Form';
import Button from '../../components/Button';
import Col from '../../components/Col';
import File from '../../components/File';
import Input from '../../components/Input';
import Row from '../../components/Row';
import Checkbox from '../../components/Checkbox';
import Toggle from '../../components/Toggle';
import WithNavigation from '../../layouts/WithNavigation';
import { useSelector, useDispatch } from 'react-redux';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Anchor from '../../components/Anchor';
import { updateUserProfile } from '../../store/actions/auth';
import { upload } from '../../helpers/upLoadHelper';
import { PATHS, USER_ROLES } from '../../common/constants';
import {
  getUserProfileDetails,
  setSettingsForm,
  updateNotificationDetails,
} from '../../store/actions/settings';
import { selectUserProfileDetails } from '../../store/selectors/settings';
import Loader from '../../components/Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { variables, Images } from '../../Tenants';
import { onCheckUserCanAccessTheModule } from '../../helpers/validationHelper';
import { onCheckDocument } from '../../helpers/CommonHelpers';
import {
  getSystemLevelNotifications,
  updateSystemLevelNotification,
} from '../../services/client.ts';
import { toast } from 'react-toastify';
import './Settings.scss';

const validEmailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const Settings = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthenticatedUser);
  const settings = useSelector(selectUserProfileDetails);
  const loader = useSelector(selectFormLoader);

  const [state, setState] = useState({
    showOverlay: false,
    changePassword: false,
    changeNotes: false,
    saveClicked: false,
    formData: {},
    profilePic: null,
    errors: {},
    systemLevelNotifications: [],
    CalendlyAPIKeyHidden: true,
  });

  useEffect(() => {
    dispatch(getUserProfileDetails(user.id));
    dispatch(
      setSettingsForm({
        companyZip: settings.companyZip || '',
        companyAddress: settings.companyAddress || '',
        companyName: settings.companyName || '',
        companyEmail: settings.companyEmail || '',
        companyCity: settings.companyCity || '',
        companyPhone: settings.companyPhone || '',
        companyState: settings.companyState || '',
        companyLogo: settings.companyLogo || '',
      })
    );

    fetchSystemLevelNotifications();
  }, []);

  const fetchSystemLevelNotifications = () => {
    getSystemLevelNotifications()
      .then((response) => {
        if (response.status == 200) {
          response
            .json()
            .then((jsonResponse) => {
              setState({
                ...state,
                systemLevelNotifications: jsonResponse,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateCompanyDetails = async () => {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    let errors = {};

    if (
      settings.companyName == null ||
      settings.companyName.trim().length === 0
    ) {
      errors.companyName = 'Please Enter Company Name !';
      errors.errors = true;
    }

    if (
      settings.companyAddress == null ||
      settings.companyAddress.trim().length === 0
    ) {
      errors.companyAddress = 'Please Enter Company Address !';
      errors.errors = true;
    }

    if (
      settings.companyEmail == null ||
      settings.companyEmail.trim().length === 0
    ) {
      errors.companyEmail = 'Please Enter Company Email !';
      errors.errors = true;
    }

    if (
      settings.companyEmail != null &&
      !validEmailRegex.test(settings.companyEmail.toLowerCase())
    ) {
      errors.companyEmail = 'Please Enter Valid Company Email !';
      errors.errors = true;
    }

    if (settings.companyPhone == null || settings.companyPhone.length < 10) {
      errors.companyPhone = 'Please Enter a 10 digit Phone Number';
      errors.errors = true;
    }

    if (settings.companyPhone == null || settings.companyPhone.length > 20) {
      errors.companyPhone = 'Please Enter a Valid Phone Number';
      errors.errors = true;
    } else if (
      !settings.companyPhone == null ||
      !settings.companyPhone.match(phoneno)
    ) {
      errors.companyPhone = 'Please Enter a Valid Phone Number';
      errors.errors = true;
    }

    setState({ ...state, errors, saveClicked: true });

    if (!errors.errors) {
      let imageUrl = null;

      if (
        settings.selectedCompanyLogo &&
        settings.selectedCompanyLogo.length === 1
      ) {
        imageUrl = await upload(settings.selectedCompanyLogo[0]);
      }

      let data = {
        userId: user.id,
        companyName: settings.companyName,
        companyAddress: settings.companyAddress,
        companyCity: settings.companyCity,
        companyState: settings.companyState,
        companyZip: settings.companyZip,
        companyEmail: settings.companyEmail,
        companyPhone: settings.companyPhone,
        companyLogo: imageUrl ? imageUrl : settings.companyLogo,
      };
      dispatch(updateCompanyDetails(data));
    }
  };

  const updateUserDetailsValidation = async () => {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    let errors = {};
    let imageUrl = null;

    if (settings && settings.firstname.trim().length === 0) {
      errors.firstname = 'Please Enter First Name !';
      errors.errors = true;
    }

    if (settings && settings.lastname.trim().length === 0) {
      errors.lastname = 'Please Enter Last Name !';
      errors.errors = true;
    }

    if (settings.email.trim().length === 0) {
      errors.email = 'Please Enter Email !';
      errors.errors = true;
    }

    if (!validEmailRegex.test(settings.email.toLowerCase())) {
      errors.email = 'Please Enter Valid Email !';
      errors.errors = true;
    }

    if (settings.phone.length < 10) {
      errors.phone = 'Please Enter a 10 digit Phone Number';
      errors.errors = true;
    }

    if (settings.phone.length > 20) {
      errors.phone = 'Phone Number can not be more than 20 digits';
      errors.errors = true;
    } else if (!settings.phone.match(phoneno)) {
      errors.phone = 'Please Enter a Valid Phone Number';
      errors.errors = true;
    }

    setState({ ...state, errors, saveClicked: true });
    if (!errors.errors) {
      if (
        settings.selectedProfileImage &&
        settings.selectedProfileImage.length > 0
      ) {
        imageUrl = await upload(settings.selectedProfileImage[0]);
      }

      let phone = settings.phone;
      let cleaned = ('' + phone).replace(/\D/g, '');
      let formattedNumber = cleaned;
      if (cleaned.length === 10) {
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        formattedNumber = match[1] + '-' + match[2] + '-' + match[3];
      }

      let params = {
        id: settings.id,
        email: settings.email,
        username: settings.email,
        firstname: settings.firstname,
        lastname: settings.lastname,
        phone: formattedNumber,
        profileImage: imageUrl ? imageUrl : settings.profileImage,
        CreatedBy: user.id,
        RoleName: user.roles[0].role.name,
        RoleId: user.roles[0].role.id,
        calendlyAPIKey: settings.calendlyAPIKey,
      };
      if (
        user.roles[0].role.name === 'Property Developer' ||
        user.roles[0].role.name === 'Service Provider'
      ) {
        params.calendarLink =
          settings && settings.calendarLink ? settings.calendarLink.trim() : '';
      }

      let response = await dispatch(updateUserProfile(params));
      if (response) {
        setTimeout(() => {
          setSaveClicked();
        }, 2000);
      }
    }
  };

  const setSaveClicked = () => {
    setState({
      ...state,
      saveClicked: false,
    });
  };

  const handleToggleChangeForSystemLevelNotifications = (
    systemLevelNotificationId,
    toggled
  ) => {
    updateSystemLevelNotification({
      id: systemLevelNotificationId,
      isActive: toggled,
    })
      .then((response) => {
        if (response.status == 200 || response.ok) {
          fetchSystemLevelNotifications();
        } else {
          toast.error("Couldn't update the notification settings", {
            autoClose: 12000,
            position: 'top-center',
          });
        }
      })
      .catch((error) => {
        toast.error('Something went wrong.', {
          autoClose: 12000,
          position: 'top-center',
        });
      });
  };

  const saveNotificationSettings = () => {
    const { allowEmail, allowStatus, allowNotes, noteNotification } = settings;
    let data = {
      UserId: user.id,
      allowEmail,
      allowStatus,
      allowNotes,
      noteNotification: allowNotes
        ? noteNotification
        : {
            serviceRequests: false,
            properties: false,
            suites: false,
            assets: false,
            inventoryItems: false,
            contacts: false,
          },
    };
    dispatch(updateNotificationDetails(data));
  };

  const { noteNotification } = settings;
  let homeOwnerCheck =
    user &&
    user.roles &&
    user.roles.length > 0 &&
    user.roles[0].role.name === 'Home Owner'
      ? true
      : false;
  let occupentCheck =
    user &&
    user.roles &&
    user.roles.length > 0 &&
    user.roles[0].role.name === 'Occupant'
      ? true
      : false;
  const { systemLevelNotifications } = state;

  return (
    <WithNavigation
      title="Settings"
      top={
        <div className="heading">
          <div className="heading__headline">Settings</div>
        </div>
      }
      bottom={
        <div className="settings">
          {loader ? <Loader center={true} /> : null}
          <Row mdCenter>
            <Col xs={12} md={8}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updateUserDetailsValidation();
                }}
              >
                <div className="settings__section">
                  <Heading>Account Settings</Heading>
                  <Row>
                    <Col xs={12} md={6}>
                      <Input
                        label="First Name"
                        placeholder="First Name"
                        value={settings.firstname}
                        onChange={(e) =>
                          dispatch(
                            setSettingsForm({ firstname: e.target.value })
                          )
                        }
                        onfocus={() => setSaveClicked()}
                        block
                        errors={state.errors.firstname}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      <Input
                        label="Last Name"
                        placeholder="Last Name"
                        value={settings.lastname}
                        onChange={(e) =>
                          dispatch(
                            setSettingsForm({ lastname: e.target.value })
                          )
                        }
                        onfocus={() => setSaveClicked()}
                        block
                        errors={state.errors.lastname}
                      />
                    </Col>
                  </Row>
                  <Input
                    label="Email"
                    placeholder="Email"
                    value={settings.email}
                    onChange={(e) =>
                      dispatch(setSettingsForm({ email: e.target.value }))
                    }
                    onfocus={() => setSaveClicked()}
                    block
                    disabled={true}
                    errors={state.errors.email}
                  />
                  <Input
                    label="Phone"
                    placeholder="Phone"
                    value={settings.phone}
                    onChange={(e) =>
                      dispatch(setSettingsForm({ phone: e.target.value }))
                    }
                    onfocus={() => setSaveClicked()}
                    block
                    errors={state.errors.phone}
                  />
                  <File
                    label="Profile Picture"
                    onSelect={(file) =>
                      onCheckDocument(file) &&
                      dispatch(setSettingsForm({ selectedProfileImage: file }))
                    }
                    files={
                      settings.selectedProfileImage
                        ? settings.selectedProfileImage
                        : []
                    }
                    onfocus={() => setSaveClicked()}
                    image={settings.profileImage}
                    type="image"
                  />
                  {user.roles[0].role.name === 'Property Developer' ||
                  user.roles[0].role.name === 'Service Provider' ? (
                    <>
                      <Input
                        label="Calendaring link"
                        placeholder="Calendar link"
                        value={
                          settings && settings.calendarLink
                            ? settings.calendarLink
                            : ''
                        }
                        onChange={(e) =>
                          dispatch(
                            setSettingsForm({ calendarLink: e.target.value })
                          )
                        }
                        block
                      />
                      <Row>
                        <Col xs={12} md={11}>
                          <Input
                            label="Calendly API Key"
                            placeholder="Calendly API Key"
                            value={settings?.calendlyAPIKey}
                            onChange={(e) =>
                              dispatch(
                                setSettingsForm({
                                  calendlyAPIKey: e.target.value,
                                })
                              )
                            }
                            onfocus={() => setSaveClicked()}
                            block
                            mask={state.CalendlyAPIKeyHidden}
                            autoComplete={'new-password'}
                          />
                        </Col>
                        <Col>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-eye-slash"
                            viewBox="0 0 16 16"
                            style={{ marginTop: '200%', cursor: 'pointer' }}
                            onClick={() => {
                              setState({
                                ...state,
                                CalendlyAPIKeyHidden:
                                  !state.CalendlyAPIKeyHidden,
                              });
                            }}
                          >
                            {!state.CalendlyAPIKeyHidden ? (
                              <>
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                              </>
                            ) : (
                              <>
                                <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                              </>
                            )}
                          </svg>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  <Button
                    label="Save Changes"
                    size="small"
                    color="teal"
                    disabled={state.saveClicked}
                    submit
                  />
                  <br />
                  <br />
                  <br />
                  <div className="settings_changePassword">
                    <Anchor
                      path={PATHS.CHANGE_PASSWORD}
                      label="Change Password"
                    />
                  </div>
                </div>
              </form>
              {user.roles[0].role.name === 'Property Developer' ? (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    updateCompanyDetails();
                  }}
                >
                  <div className="settings__section">
                    <Heading>Company Settings</Heading>
                    <Input
                      label="Company Name"
                      placeholder="Company Name"
                      value={
                        settings.companyName === null
                          ? ''
                          : settings.companyName
                      }
                      onChange={(e) =>
                        dispatch(
                          setSettingsForm({ companyName: e.target.value })
                        )
                      }
                      onfocus={() => setSaveClicked()}
                      block
                      errors={state.errors.companyName}
                    />
                    <Input
                      label="Address"
                      placeholder="Address"
                      value={
                        settings.companyAddress === null
                          ? ''
                          : settings.companyAddress
                      }
                      onChange={(e) =>
                        dispatch(
                          setSettingsForm({ companyAddress: e.target.value })
                        )
                      }
                      onfocus={() => setSaveClicked()}
                      block
                      errors={state.errors.companyAddress}
                    />
                    <Row>
                      <Col xs={12} md={4}>
                        <Input
                          label="City"
                          placeholder="City"
                          value={
                            settings.companyCity === null
                              ? ''
                              : settings.companyCity
                          }
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({ companyCity: e.target.value })
                            )
                          }
                          onfocus={() => setSaveClicked()}
                          block
                          errors={state.errors.companyCity}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <Input
                          label="State"
                          placeholder="State"
                          value={
                            settings.companyState === null
                              ? ''
                              : settings.companyState
                          }
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({ companyState: e.target.value })
                            )
                          }
                          onfocus={() => setSaveClicked()}
                          block
                          errors={state.errors.companyState}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <Input
                          label="Zip"
                          placeholder="Zip"
                          value={
                            settings.companyZip === null
                              ? ''
                              : settings.companyZip
                          }
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({ companyZip: e.target.value })
                            )
                          }
                          onfocus={() => setSaveClicked()}
                          block
                          errors={state.errors.companyZip}
                        />
                      </Col>
                    </Row>
                    <Input
                      label="Email"
                      placeholder="Email"
                      value={
                        settings.companyEmail === null
                          ? ''
                          : settings.companyEmail
                      }
                      onChange={(e) =>
                        dispatch(
                          setSettingsForm({ companyEmail: e.target.value })
                        )
                      }
                      onfocus={() => setSaveClicked()}
                      block
                      errors={state.errors.companyEmail}
                    />
                    <Input
                      label="Phone"
                      placeholder="Phone"
                      value={
                        settings.companyPhone === null
                          ? ''
                          : settings.companyPhone
                      }
                      onChange={(e) =>
                        dispatch(
                          setSettingsForm({ companyPhone: e.target.value })
                        )
                      }
                      onfocus={() => setSaveClicked()}
                      block
                      errors={state.errors.companyPhone}
                    />
                    <File
                      label="Company Logo"
                      onSelect={(file) =>
                        onCheckDocument(file) &&
                        dispatch(setSettingsForm({ selectedCompanyLogo: file }))
                      }
                      files={
                        settings.selectedCompanyLogo
                          ? settings.selectedCompanyLogo
                          : []
                      }
                      image={settings.companyLogo}
                      type="image"
                    />
                    <Button
                      label="Save Changes"
                      disabled={state.saveClicked}
                      size="small"
                      color="teal"
                      submit
                    />
                    <br />
                    <br />
                    <br />
                  </div>
                </form>
              ) : null}

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  saveNotificationSettings();
                }}
              >
                <div className="settings__section">
                  <Heading>Notifications</Heading>
                  <Toggle
                    label="Allow Email Notifications"
                    value={settings.allowEmail}
                    onToggle={(value) =>
                      dispatch(
                        setSettingsForm({ allowEmail: !settings.allowEmail })
                      )
                    }
                  />
                  <Toggle
                    label="Status Updates"
                    description="These are notifications about service requests activity, like when a service request is assigned to you  or changes status."
                    value={settings.allowStatus}
                    onToggle={(value) =>
                      dispatch(setSettingsForm({ allowStatus: !value }))
                    }
                  />
                  {homeOwnerCheck || occupentCheck ? (
                    ''
                  ) : (
                    <Toggle
                      label="Notes"
                      description="These are notifications for notes on the following:"
                      value={settings.allowNotes}
                      onToggle={(value) =>
                        dispatch(setSettingsForm({ allowNotes: !value }))
                      }
                    />
                  )}
                  {settings.allowNotes ? (
                    <Row>
                      <Col xs={12} md={6}>
                        <Checkbox
                          label="Service Requests"
                          value={settings.noteNotification.serviceRequests}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  serviceRequests:
                                    !settings.noteNotification.serviceRequests,
                                },
                              })
                            )
                          }
                        />
                        <Checkbox
                          label="Properties"
                          value={settings.noteNotification.properties}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  properties:
                                    !settings.noteNotification.properties,
                                },
                              })
                            )
                          }
                        />
                        <Checkbox
                          label={variables.Suite + 's'}
                          value={settings.noteNotification.suites}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  suites: !settings.noteNotification.suites,
                                },
                              })
                            )
                          }
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <Checkbox
                          label="Assets"
                          value={settings.noteNotification.assets}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  assets: !settings.noteNotification.assets,
                                },
                              })
                            )
                          }
                        />
                        <Checkbox
                          label="Inventory Items"
                          value={settings.noteNotification.inventoryItems}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  inventoryItems:
                                    !settings.noteNotification.inventoryItems,
                                },
                              })
                            )
                          }
                        />
                        <Checkbox
                          label="Contacts"
                          value={settings.noteNotification.contacts}
                          onChange={(e) =>
                            dispatch(
                              setSettingsForm({
                                ...settings,
                                noteNotification: {
                                  ...noteNotification,
                                  contacts: !settings.noteNotification.contacts,
                                },
                              })
                            )
                          }
                        />
                      </Col>
                    </Row>
                  ) : null}
                  <Button
                    label="Save Changes"
                    size="small"
                    color="teal"
                    submit
                  />
                </div>
                {onCheckUserCanAccessTheModule([
                  USER_ROLES.PROPERTY_DEVELOPER,
                  USER_ROLES.ADMIN,
                  USER_ROLES.SUPER_ADMIN,
                ]) ? (
                  <div className="settings__section">
                    <Heading>System Level Notifications</Heading>
                    <div>
                      <p
                        style={{
                          color: 'var(--color-ink-lightest)',
                          fontSize: '1.5rem',
                          lineHeight: '2.4rem',
                          width: '100%',
                        }}
                      >
                        Control what notifications are sent from Juniper below.
                        Note that with turning any of these notifications off,
                        this will affect all user types including property
                        developers, service providers, service managers,
                        homeowners and occupants.
                      </p>
                    </div>
                    {systemLevelNotifications.length > 0 ? (
                      systemLevelNotifications.map((notification) => (
                        <div key={notification.id} className="settings__item">
                          <Toggle
                            label={notification.name}
                            value={notification.isActive}
                            description={notification.description}
                            onToggle={(value) =>
                              handleToggleChangeForSystemLevelNotifications(
                                notification.id,
                                !value
                              )
                            }
                          />
                        </div>
                      ))
                    ) : (
                      <Loader center={true} />
                    )}
                  </div>
                ) : (
                  <></>
                )}
                {onCheckUserCanAccessTheModule([
                  USER_ROLES.PROPERTY_DEVELOPER,
                  USER_ROLES.ADMIN,
                  USER_ROLES.SUPER_ADMIN,
                  USER_ROLES.SERVICE_MANAGER,
                  USER_ROLES.STRATA_MANAGER,
                ]) && (
                  <div className="settings_qrcodeView">
                    <Heading>Scan the QR Code from mobile app</Heading>
                    <img src={Images.QRCode} className="settings_qrcodeImage" />
                  </div>
                )}
                <div className="card__body">
                  For the best experience with notifications, please make sure
                  you have turned on the browser alerts at all times.
                </div>
              </form>
            </Col>
          </Row>
        </div>
      }
    />
  );
};

export default Settings;
